/* =====================================================================
   NUVIA · Ella de Nuevo — comportamiento de la landing
   Cada sección marca su raíz con data-edn="tipo". Este archivo se carga
   desde todas las secciones, pero solo se inicializa una vez.
   ===================================================================== */
(function () {
  if (window.__ednLanding) return;
  window.__ednLanding = true;
  document.documentElement.classList.add('edn-js');

  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11.1.14/swiper-bundle.min.js';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11.1.14/swiper-bundle.min.css';
  var swiperPromise = null;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (swiperPromise) return swiperPromise;
    swiperPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-edn-swiper]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        link.setAttribute('data-edn-swiper', '');
        document.head.appendChild(link);
      }
      var s = document.createElement('script');
      s.src = SWIPER_JS;
      s.async = true;
      s.onload = function () { resolve(window.Swiper); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return swiperPromise;
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Swiper desactiva el loop si hay pocas tarjetas: las duplicamos y
     guardamos en data-edn-index a qué tarjeta original corresponde cada una. */
  function ensureLoopSlides(swiperEl, min) {
    var wrap = $('.swiper-wrapper', swiperEl);
    if (!wrap) return 0;
    var originals = $$(':scope > .swiper-slide', wrap);
    var n = originals.length;
    originals.forEach(function (s, i) { s.setAttribute('data-edn-index', i); });
    if (!n) return 0;
    while (wrap.children.length < min) {
      originals.forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        wrap.appendChild(c);
      });
    }
    return n;
  }

  /* ---------- Animación de entrada ---------- */
  var io = null;
  function initFade(root) {
    var els = $$('.edn-fade', root);
    if (window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Acordeón genérico con max-height ---------- */
  function bindMaxHeightAccordion(item, toggle, content, openClass) {
    content.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height' && item.classList.contains(openClass)) content.style.maxHeight = 'none';
    });
    toggle.addEventListener('click', function () {
      var open = item.classList.toggle(openClass);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.offsetHeight; // fuerza el reflow para que la transición de cierre arranque
        content.style.maxHeight = '0px';
      }
    });
  }

  /* ---------- 1. Producto principal ---------- */
  function initMain(root) {
    // Galería
    var main = $('.edn-gallery__main', root);
    var thumbs = $$('.edn-gallery__thumb', root);
    var strip = $('.edn-gallery__thumbs', root);
    var isMobile = function () { return window.matchMedia('(max-width: 786px)').matches; };
    if (main) {
      loadSwiper().then(function (Swiper) {
        var sw = new Swiper(main, {
          navigation: { nextEl: $('.edn-gallery__btn--next', root), prevEl: $('.edn-gallery__btn--prev', root) },
          autoHeight: true,
          speed: 500,
          breakpoints: { 0: { slidesPerView: 1, spaceBetween: 4 }, 768: { slidesPerView: 1, spaceBetween: 20 }, 1024: { slidesPerView: 1, spaceBetween: 0 } }
        });
        function setActive(i) {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          var t = thumbs[i];
          if (!t) return;
          t.classList.add('is-active');
          if (isMobile() && strip) {
            strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
          }
        }
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var i = Number(t.getAttribute('data-index'));
            sw.slideTo(i, 500);
            setActive(i);
            if (!isMobile()) {
              setTimeout(function () {
                window.scrollTo({ top: main.getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth' });
              }, 550);
            }
          });
        });
        sw.on('slideChange', function () { setActive(sw.realIndex); });
        setActive(0);
      });
    }
    var tp = $('.edn-gallery__thumb-btn--prev', root), tn = $('.edn-gallery__thumb-btn--next', root);
    if (tp && tn && strip) {
      var upd = function () {
        var max = strip.scrollWidth - strip.clientWidth;
        tp.classList.toggle('is-disabled', strip.scrollLeft <= 2);
        tn.classList.toggle('is-disabled', strip.scrollLeft >= max - 2);
      };
      tp.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.6, behavior: 'smooth' }); });
      tn.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.6, behavior: 'smooth' }); });
      strip.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }

    // Fecha estimada de entrega (días hábiles, en español)
    $$('.edn-odg', root).forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 3;
      var d = new Date();
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      var months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      var out = $('.edn-odg__date', el);
      if (out) out.textContent = d.getDate() + ' de ' + months[d.getMonth()];
    });

    // Barra de reposición
    $$('.edn-restock__fill', root).forEach(function (fill) {
      var p = Math.max(0, Math.min(100, parseInt(fill.getAttribute('data-progress'), 10) || 0));
      var run = function () { requestAnimationFrame(function () { fill.style.width = p + '%'; }); };
      if ('IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { run(); o.disconnect(); }
        });
        o.observe(fill);
      } else { run(); }
    });

    // Acordeones
    $$('.edn-acc', root).forEach(function (acc) {
      var t = $('.edn-acc__toggle', acc), c = $('.edn-acc__content', acc);
      if (t && c) bindMaxHeightAccordion(acc, t, c, 'is-open');
    });

    // Packs nativos (opcional): actualiza la cantidad que se agrega al carrito
    var qty = $('.edn-qty', root);
    $$('.edn-bundle input', root).forEach(function (input) {
      input.addEventListener('change', function () {
        $$('.edn-bundle', root).forEach(function (b) { b.classList.remove('is-selected'); });
        input.closest('.edn-bundle').classList.add('is-selected');
        if (qty) qty.value = input.value;
      });
    });
    var checked = $('.edn-bundle input:checked', root);
    if (checked && qty) qty.value = checked.value;

    // Si el tema no define <product-form>, el botón agrega por AJAX y lleva al carrito.
    var pf = $('product-form', root);
    if (pf && !window.customElements.get('product-form')) {
      var form = $('form', pf);
      form && form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[type="submit"]', form);
        btn && btn.classList.add('loading');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) {
            var w = $('.product-form__error-message-wrapper', pf);
            if (w) { w.hidden = false; $('.product-form__error-message', w).textContent = res.description || res.message; }
            btn && btn.classList.remove('loading');
            return;
          }
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }).catch(function () { form.submit(); });
      });
    }

    // Videos de la comunidad
    var cs = $('.edn-community .swiper', root);
    if (cs) {
      loadSwiper().then(function (Swiper) {
        new Swiper(cs, {
          slidesPerView: 2.2, spaceBetween: 12,
          navigation: { nextEl: $('.edn-community .edn-arrow--next', root), prevEl: $('.edn-community .edn-arrow--prev', root) }
        });
      });
    }
  }

  /* ---------- 2. Video-reseñas ---------- */
  function initVideoReviews(root) {
    var el = $('.swiper', root);
    if (el) {
      if (window.matchMedia("(max-width: 767px)").matches) ensureLoopSlides(el, 8);
      loadSwiper().then(function (Swiper) {
        new Swiper(el, {
          slidesPerView: 3.8, spaceBetween: 16, speed: 1000,
          breakpoints: {
            0: { slidesPerView: 1.3, spaceBetween: 12, centeredSlides: true, initialSlide: 1, loop: true },
            768: { slidesPerView: 2.1, spaceBetween: 12, centeredSlides: true, initialSlide: 1 },
            1024: { slidesPerView: 3.9, spaceBetween: 16, centeredSlides: false, initialSlide: 0 }
          }
        });
      });
    }
    // Reproducir/pausar: solo un video a la vez
    root.addEventListener('click', function (e) {
      var card = e.target.closest('.edn-vr__card');
      if (!card) return;
      var v = $('video', card), btn = $('.edn-vr__play', card);
      if (!v) return;
      $$('.edn-vr__card video').forEach(function (o) {
        if (o !== v && !o.paused) {
          o.pause();
          var ob = $('.edn-vr__play', o.closest('.edn-vr__card'));
          ob && ob.classList.remove('is-hidden');
        }
      });
      if (v.paused) {
        var p = v.play();
        btn && btn.classList.add('is-hidden');
        if (p && p.catch) p.catch(function () { btn && btn.classList.remove('is-hidden'); });
      } else {
        v.pause();
        btn && btn.classList.remove('is-hidden');
      }
    });
    $$('video', root).forEach(function (v) {
      v.addEventListener('ended', function () {
        var b = $('.edn-vr__play', v.closest('.edn-vr__card'));
        b && b.classList.remove('is-hidden');
      });
    });
  }

  /* ---------- 5. Apoyo específico (tabs + acordeón) ---------- */
  function initTargeted(root) {
    var tabs = $$('.edn-ht__tab', root);
    var panels = $$('.edn-ht__desktop .edn-ht__panel', root);
    function act(i) {
      tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('mouseenter', function () { act(i); });
      t.addEventListener('click', function () { act(i); });
    });
    var items = $$('.edn-ht__item', root);
    items.forEach(function (item) {
      var trig = $('.edn-ht__trigger', item);
      trig && trig.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var t = $('.edn-ht__trigger', i);
          t && t.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) { item.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------- 6. Reseñas ---------- */
  function initReviews(root) {
    var el = $('.swiper', root);
    if (!el) return;
    if (window.matchMedia("(max-width: 767px)").matches) ensureLoopSlides(el, 8);
    loadSwiper().then(function (Swiper) {
      new Swiper(el, {
        slidesPerView: 4, spaceBetween: 16, speed: 500,
        navigation: { nextEl: $('.edn-arrow--next', root), prevEl: $('.edn-arrow--prev', root) },
        breakpoints: {
          0: { slidesPerView: 1.2, spaceBetween: 14, loop: true, centeredSlides: true, initialSlide: 1 },
          768: { slidesPerView: 4, spaceBetween: 16 }
        }
      });
    });
  }

  /* ---------- 7. Ingredientes (Leer más en móvil) ---------- */
  function initIngredients(root) {
    $$('.edn-ing__bcol', root).forEach(function (col) {
      var b = $('.edn-ing__more', col);
      if (!b) return;
      b.addEventListener('click', function () {
        var open = col.classList.toggle('is-open');
        b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
      });
    });
  }

  /* ---------- 9. Rutina semana a semana ---------- */
  function initTimeline(root) {
    var el = $('.swiper', root);
    var tabs = $$('.edn-tl__tab', root);
    if (!el) return;
    ensureLoopSlides(el, 12);
    loadSwiper().then(function (Swiper) {
      function setTab(i) {
        tabs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      }
      function phaseOf(s) {
        var slide = s.slides[s.activeIndex];
        return slide ? parseInt(slide.getAttribute('data-edn-index'), 10) || 0 : 0;
      }
      var sw = new Swiper(el, {
        loop: true, centeredSlides: true, speed: 600, grabCursor: true, initialSlide: 0,
        slidesPerView: 1.1, spaceBetween: 14,
        navigation: { nextEl: $('.edn-arrow--next', root), prevEl: $('.edn-arrow--prev', root) },
        breakpoints: {
          0: { slidesPerView: 1.15, spaceBetween: 6 },
          768: { slidesPerView: 1.6, spaceBetween: 20 },
          1024: { slidesPerView: 1.9, spaceBetween: 16 },
          1400: { slidesPerView: 2.3, spaceBetween: 16 }
        },
        on: {
          init: function (s) { setTab(phaseOf(s)); },
          slideChange: function (s) { setTab(phaseOf(s)); }
        }
      });
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { setTab(i); sw.slideToLoop(i, 600); }); });
    });
  }

  /* ---------- 12. FAQ ---------- */
  function initFaq(root) {
    $$('.edn-faq__item', root).forEach(function (item) {
      var q = $('.edn-faq__q', item);
      q && q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  var INIT = {
    main: initMain,
    'video-reviews': initVideoReviews,
    targeted: initTargeted,
    reviews: initReviews,
    ingredients: initIngredients,
    timeline: initTimeline,
    faq: initFaq
  };

  /* ---------- Videos diferidos ----------
     Los videos llevan data-edn-src y se cargan recién cuando su carrusel
     se acerca a la pantalla. Se observa el contenedor (no cada video) para
     que las tarjetas fuera del carrusel ya estén listas al deslizar. */
  function loadVideos(container) {
    $$('video[data-edn-src]', container).forEach(function (v) {
      v.src = v.getAttribute('data-edn-src');
      v.removeAttribute('data-edn-src');
      if (v.autoplay) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  function initLazyVideos(scope) {
    var groups = [];
    $$('video[data-edn-src]', scope).forEach(function (v) {
      var g = v.closest('.swiper') || v.closest('[data-edn]') || v.parentNode;
      if (groups.indexOf(g) === -1) groups.push(g);
    });
    if (!groups.length) return;
    if (!('IntersectionObserver' in window)) { groups.forEach(loadVideos); return; }
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { vo.unobserve(en.target); loadVideos(en.target); }
      });
    }, { rootMargin: '600px 0px' });
    groups.forEach(function (g) { vo.observe(g); });
  }

  function boot(scope) {
    $$('[data-edn]', scope).forEach(function (root) {
      if (root.__ednDone) return;
      root.__ednDone = true;
      var fn = INIT[root.getAttribute('data-edn')];
      if (fn) { try { fn(root); } catch (err) { console.error('[edn]', err); } }
    });
    initFade(scope);
    initLazyVideos(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
